import { render, staticRenderFns } from "./Supp.vue?vue&type=template&id=d0ca4ee2&lang=pug"
import script from "./Supp.vue?vue&type=script&lang=js"
export * from "./Supp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports